module.exports = __webpack_public_path__ + "img/logo.0d2ba505.svg";